import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { BehaviorSubject } from "rxjs";
import { MenuItemsProvider, MenuItemWithId } from "../providers/menu-items.provider";

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  providers: [MenuItemsProvider],
  template: `
    <ul class="layout-menu">
      <ng-container *ngFor="let item of model$ | async; let i = index; trackBy: trackByFn">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
      </ng-container>
    </ul>
  `
})
export class AppMenu implements OnInit {
  model$!: BehaviorSubject<MenuItemWithId[]>;


  constructor(
    private menuItemsProvider: MenuItemsProvider,
  ) {
  }

  ngOnInit() {
    this.model$ = this.menuItemsProvider.menuItems$;
  }

  trackByFn(index: number, item: MenuItemWithId) {
    return item.id;
  }
}
